module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Home","recommended_sites":"Recommended Sites","click_to_join":"Click Here To Join"},"ja":{"browser_title":"トップページ","recommended_sites":"おすすめサイト情報","click_to_join":"入会はこちら"}}')
  delete Component.options._Ctor
}
